import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

export function addBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.child.map((child, i) => {
    if (child.current != null && child.current?.child.current?.props.sectionName === 'ReportingAuthorityTemplatePreset') {
      child.current?.setState({ showModal: true, componentType: 'Create' });

      setTimeout(() => {
        child.current?.customForm.current?.additionalFormRef.current?.child.current?.setState({ defaultSelectedRowKeys: [], reportingAuthorityTemplatePresetContentList: [], selectedRowKeys: [] });
        child.current?.customForm.current?.additionalFormRef.current?.child.current?.getReportingAuthorityTemplateData();
      }, config.setTimeoutMilliSecond * 10);
    }
  })
}

export function editBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ showModal: true, componentType: 'Edit' });
  setTimeout(() => {
    httpClient
      .get(pageComponent.props.areaName + '/' + sectionName + '/' + parameter.key)
      .then(({ data }) => {
        if (data.result) {
          sectionComponent.customForm.current?.setState({ currentDataKey: data.data.key });

          sectionComponent.customForm.current?.formRef.current?.setFieldsValue(data.data);
          sectionComponent.customForm.current?.setState({ formData: data.data });

          let defaultSelectedRowKeys = [];
          let reportingAuthorityTemplatePresetContentList = [];
          data.data.ReportingAuthorityTemplatePresetContentList.map((reportingAuthorityTemplatePresetContent, i) => {
            defaultSelectedRowKeys.push(reportingAuthorityTemplatePresetContent.ReportingAuthorityTemplateId);
            reportingAuthorityTemplatePresetContentList.push(reportingAuthorityTemplatePresetContent);
          })
          setTimeout(() => {
            sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ defaultSelectedRowKeys, reportingAuthorityTemplatePresetContentList, selectedRowKeys: [] });
            sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.getReportingAuthorityTemplateData();
          }, config.setTimeoutMilliSecond * 10);
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }, config.setTimeoutMilliSecond);
}

export function showSelectedItemsOnlyOnChange({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  let filteredData = parameter
    ? sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.state.data.filter((item) => sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.state.reportingAuthorityTemplatePresetContentList.map(item => item.ReportingAuthorityTemplateId).includes(item.key))
    : sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.state.data;
  sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ filteredData });
}
